<template>
  <DateColumn :date="column.onboardedAt" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import DateColumn from '@/components/GraphqlDataTable/columns/DateColumn.vue'

const EmploymentOnboardedDateColumn = graphql(`
  fragment EmploymentOnboardedDateColumn on Employment {
    id
    onboardedAt
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentOnboardedDateColumn> }>()

const column = computed(() => useFragment(EmploymentOnboardedDateColumn, props.row))
</script>
